import React, { useState,} from "react";
import { StyleSheet, TouchableOpacity } from 'react-native';

import { View } from '../../../components/Themed';
import { Entypo } from '@expo/vector-icons';
import Utilities from "../~Utilities/Utilities";
import { FontInfo } from "../~Utilities/Constants";

/*   -------------------------------------------------------------------   */

export interface IDotInfo
{
  clickEvent: (iIndex: number)=>void;
  iIndex    : number;
  bEvt      : boolean;
  onBlue    : (iIndex:number)=>void;
}

/*   ====================================================================   */

export default class Dots extends React.Component<IDotInfo>
  {
  // const [m_index, setIndex]               = useState(iIndex);

  /*   -------------------------------------------------------------------   */

  state = {m_index : 0, b_evt: this.props.bEvt};

  /*   -------------------------------------------------------------------   */

  constructor(props)
  {
  super(props);

  this.state     = {m_index: this.props.iIndex, b_evt:this.state.b_evt};
  this.SetIndex  = this.SetIndex.bind(this);
  this.SetEvt    = this.SetEvt.bind(this);
  }

/*   -------------------------------------------------------------------   */

 SetIndex(iIndex : number)
 {
 if (this.state.m_index != iIndex)
    {
    this.setState({m_index : iIndex});
    Utilities.Sendlog("page: " + iIndex);

    this.props.onBlue(this.state.m_index);
    
    return(true);
    }

 return(false);    
 }

 /*   --------------------------------------------------------------------   */

 SetEvt(bEvt : boolean)
 {
 if (this.state.b_evt != bEvt)
    {
    this.setState({b_evt : bEvt});
    }
 }

 /*   --------------------------------------------------------------------   */

  render()
  {
    //this.props.onBlue(this.state.m_index);

    return(
      <View style={{alignSelf:'center', flexDirection:'row', backgroundColor:'transparent'}}>

      <TouchableOpacity style={{minWidth:80, backgroundColor:'transparent', alignItems:'flex-end', justifyContent:'center'}} 
        onPress={()=> 
          {
          if (this.state.m_index == 0) 
            this.props.clickEvent(3); 
          else
            this.props.clickEvent(this.state.m_index - 1);
          }}>
       <Entypo style={{marginRight:10}} name="chevron-small-left" size={20} color={FontInfo.sDivider} />
      </TouchableOpacity>

      <TouchableOpacity style={styles.dot_cover} onPress={()=> {this.props.clickEvent(0)}}>
        <TouchableOpacity style={this.state.m_index == 0? styles.dot_on : styles.dot_off} onPress={()=> {this.props.clickEvent(0)}} />
      </TouchableOpacity>

      <TouchableOpacity style={styles.dot_cover} onPress={()=> {this.props.clickEvent(1)}}>
        <TouchableOpacity style={this.state.m_index == 1? styles.dot_on : styles.dot_off} onPress={()=> {this.props.clickEvent(1)}} />
      </TouchableOpacity>

      <TouchableOpacity style={styles.dot_cover} onPress={()=> {this.props.clickEvent(2)}}>
        <TouchableOpacity style={this.state.m_index == 2? styles.dot_on : styles.dot_off} onPress={()=> {this.props.clickEvent(2)}}/>
      </TouchableOpacity>

      <TouchableOpacity style={!this.state.b_evt? {display:'none'} : [styles.dot_cover]} onPress={()=> {this.props.clickEvent(3)}}>
        <TouchableOpacity style={this.state.m_index == 3? styles.dot_on : styles.dot_off} onPress={()=> {this.props.clickEvent(3)}}/>
      </TouchableOpacity>

      <TouchableOpacity style={{minWidth:80, backgroundColor:'transparent', alignItems:'flex-start', justifyContent:'center'}} 
        onPress={()=> 
            {
            if (this.state.m_index >= (this.state.b_evt? 3 : 2)) 
              this.props.clickEvent(0);
            else
              this.props.clickEvent(this.state.m_index + 1);
            }}>
       <Entypo style={{marginLeft:10}} name="chevron-small-right" size={20} color={FontInfo.sDivider} />
      </TouchableOpacity>

      </View>
  
    );
  }

}

const styles = StyleSheet.create({
  dot_cover: 
  {
    margin:0, width:20, height:20, borderRadius:10, backgroundColor:'transparent', alignItems:'center', justifyContent:'center'
  },


  dot_on: 
  {
    margin:0, width:10, height:10, borderRadius:5, backgroundColor:'cornflowerblue'
  },

  dot_off: 
  {
    margin:0, width:10, height:10, borderRadius:5, backgroundColor:'lightgrey'
  },
});